// extracted by mini-css-extract-plugin
export default {"root":"AuthorsContent_root__vw-MF"};